// extracted by mini-css-extract-plugin
module.exports = {"container":"ta","timeTop":"ua","timeCountdown":"va","cta":"wa","disabled":"xa","product":"ya"};